import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { GET_JOURNAL_BY_ID, GET_MANUAL_JOURNALS } from '../graphql/queries/manual-journals.query';
import { CREATE_JOURNAL, PUBLISH_JOURNAL, REMOVE_JOURNAL, REMOVE_JOURNAL_ENTRY, UPDATE_JOURNAL } from '../graphql/mutations/manual-journals.mutation';

@Injectable({
  providedIn: 'root'
})
export class ManualJournalService {

  constructor(private apollo:Apollo) { }

   //fetch manual journals
   fetchManualJournals(search: string, status?: any): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_MANUAL_JOURNALS,
        variables: { search, status },
        fetchPolicy: 'no-cache',
      })
      .valueChanges.pipe(map((response) => response.data.journals));
  }

  //create journal
  createJournal(
    createJournalInput: any,
    journalEntries: any
  ): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: CREATE_JOURNAL,
      variables: {
        createJournalInput: createJournalInput,
        journalEntries: journalEntries
      },
    });
  }

   //remove journal
   removeJournal(id: number): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: REMOVE_JOURNAL,
      variables: { id },
    });
  }
   //remove journal entry
   removeJournalEntry(id: number): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: REMOVE_JOURNAL_ENTRY,
      variables: { id },
    });
  }

  updateJournal(journalInput: any,journalEntries: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: UPDATE_JOURNAL,
      variables: {
        updateJournalInput: journalInput,
        journalEntries: journalEntries
      },
    });
  }

  //get journal by id
  getJournalById(id: number): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_JOURNAL_BY_ID,
        variables: { id: id },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((response) => response.data?.journal || []));
  }

    //publish journal
    publishJournal(id: number): Observable<any> {
      return this.apollo.use('accounts').mutate({
        mutation: PUBLISH_JOURNAL,
        variables: {
          id: id,
        },
      });
    }
}
